var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3:22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7422 17.5C19.7422 22.9359 15.3234 27.3438 9.87 27.3438C8.57558 27.3455 7.29349 27.0922 6.09694 26.5985C4.90039 26.1047 3.8128 25.3801 2.89629 24.466C1.97978 23.552 1.25228 22.4663 0.75533 21.2711C0.258384 20.0758 0.00172245 18.7944 0 17.5C0 12.0619 4.41875 7.65626 9.87 7.65626C11.1646 7.65425 12.4469 7.90729 13.6437 8.40092C14.8405 8.89455 15.9284 9.61911 16.8451 10.5332C17.7619 11.4473 18.4896 12.5331 18.9866 13.7284C19.4837 14.9238 19.7405 16.2054 19.7422 17.5ZM30.5703 17.5C30.5703 22.6188 28.3609 26.7663 25.6353 26.7663C22.9097 26.7663 20.7003 22.6166 20.7003 17.5C20.7003 12.3813 22.9097 8.23376 25.6353 8.23376C28.3609 8.23376 30.5703 12.3834 30.5703 17.5ZM35 17.5C35 22.085 34.2234 25.8016 33.2631 25.8016C32.305 25.8016 31.5284 22.0828 31.5284 17.5C31.5284 12.915 32.305 9.19845 33.2653 9.19845C34.2234 9.19845 35 12.915 35 17.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3:22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.c4ff567cd2c537916908f9c1ea89ce7e.svg";
export { ForwardRef as ReactComponent };